import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const companySettingsAccountSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("company-settings-account-settings-nro-heading", "Account Profile"),
  pageNameForTracking: () => "Account Profile",
  icon: "nav-system-manage-account",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
